import { AddressDetails as DefaultAddressDetails } from "src/components/feature/Onboarding";
const AddressDetails = () => {
  return <DefaultAddressDetails />;
};

export default AddressDetails;
